import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import propTypes from 'prop-types'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { onSubmit } from './effects'
import { InputFieldWithLabel } from '../../Form/Fields.jsx'
import { Modal, ModalHeader, ModalSubHeader, ModalContent } from '../index'
import { Button } from '../../Button'

export const InviteFriendsModal = ({ open, close, referralsPath }) => {
  const [inviteSent, setInviteSent] = useState(false)
  const [error, setError] = useState(null)
  const [email, setEmail] = useState('')

  // Reset the state of the modal when closing
  const onClose = () => {
    setInviteSent(false)
    setError(false)
    setEmail('')
    close()
  }
  return (
    <Modal open={open} onClose={onClose} error={error}>
      {
        inviteSent
        ? <InviteSentContent onClose={onClose} setInviteSent={setInviteSent} email={email} />
        : <SendInviteContent
            setEmail={setEmail}
            onClose={onClose}
            setInviteSent={setInviteSent}
            referralsPath={referralsPath}
            setError={setError}
          />
      }
    </Modal>
  )
}

const SendInviteContent = ({ onClose, referralsPath, setInviteSent, setError, setEmail }) => {
  const [inviting, setInviting] = useState(false)
  return (
    <>
      <ModalHeader>Send an invite</ModalHeader>
      <ModalSubHeader>Help people you know reach a better financial future with a click of a button</ModalSubHeader>
      <ModalContent>
        <Formik
          initialValues={{ email: '', name: '' }}
          onSubmit={onSubmit(referralsPath, setInviting, setInviteSent, setError, setEmail)}
          validationSchema={
            Yup.object().shape({
              email: Yup.string().email(`This doesn't look like a valid email.`).required('An email is required'),
              name: Yup.string().required('A name for the recipient is required.')
            })
          }
        >
          {({ isValid, isSubmitting }) => (
            <Form>
              <Box
                className='app-form'
              >
                <InputFieldWithLabel name='name' label='Name' />
                <InputFieldWithLabel name='email' label='Email' />
                <Box
                  mt='1.5rem'
                  className='flex flex-col gap-4 mb-4 xs:flex-row'
                >
                  <Button fullWidth secondary onClick={onClose}>{inviting ? 'Inviting...' : 'Go back'}</Button>
                  <Button fullWidth disabled={!isValid || isSubmitting || inviting} type='submit' primary>{inviting ? 'Inviting...' : 'Send invite'}</Button>
                </Box>
                <Box
                  display='flex'
                  justifyContent='center'
                  alignItems='center'
                  flexDirection='column'
                >
                  <small>We'll send an invite to the email above</small>
                  <small>Let them know it's on it's way</small>
                </Box>
              </Box>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </>
  )
}

const InviteSentContent = ({ onClose, setInviteSent, email }) => {
  return (
    <>
      <ModalHeader>Nicely done!</ModalHeader>
      <ModalSubHeader>Your invite is on it's way to {email}</ModalSubHeader>
      <ModalContent>
        <p className='text-center'>We'll notify you when it's been accepted so you can encourage them on their way to financial freedom</p>
        <Box
          display='flex'
          justifyContent='center'
          className='flex-col gap-4 xs:flex-row'
        >
          <Button fullWidth secondary onClick={onClose}>Close</Button>
          <Button fullWidth primary onClick={() => setInviteSent(false)}>Send another invite</Button>
        </Box>
      </ModalContent>
    </>
  )
}

InviteFriendsModal.propTypes = {
  open: propTypes.bool.isRequired,
  close: propTypes.func.isRequired,
  referralsPath: propTypes.string.isRequired
}
